import { createFileRoute } from '@tanstack/react-router';

export default function Users() {
  return <div>Users</div>;
}

export const Route = createFileRoute('/_authenticated/dashboard/accounts/users')({
  component: Users,
});
